const fr = {
  "schema.column": (actual: string, expected: string) =>
    `${actual} n’est pas une valeur attendue pour le champ "column". Les options possibles sont ${expected}`,
  "schema.block.kind": `Le type de bloc spécifié dans le champ "kind" n'est pas pris en charge. Les options possibles sont "TEXT", "HEADING", "PLOT", "COMMENT".`,
  "schema.block.position": `Les valeurs spécifiées dans la section "position" doivent être des entiers positifs.`,
  "schema.identifier":
    "L'identifiant ne doit contenir que des lettres, des chiffres et des traits de soulignement.",
  "schema.layer.mark": (actual: string, expected: string) =>
    `${actual} n’est pas une valeur attendue pour le champ "mark". Les options possibles sont ${expected}`,
  "schema.layer.zoom": `Les valeurs "min" et "max" spécifiées dans le champ "zoom" doivent être numériques ou des dates au format aaaa-mm-jjThh:mm:ss.sssZ (ex. 2000-01-01T00:00:00.000Z).`,
  "schema.layer.zoom.gt": (min: string | number | null, max: string | number | null) =>
    `La valeur "min" doit être inférieure à la valeur "max" dans la section "zoom" (${min} > ${max}).`,
  "schema.layer.rule": `Les valeurs spécifiées dans le champ "value" de la section "rule" doivent être numériques ou des dates au format aaaa-mm-jjThh:mm:ss.sssZ (ex. 2000-01-01T00:00:00.000Z)..`,
  "schema.period": (expected: string) =>
    `Les valeurs spécifiées pour le champ “period” doivent être des durées au format ISO8601. Les autres valeurs autorisées sont ${expected}.`,
  "schema.layer.position": `La valeur spécifiée dans le champ "layer.position" doit être "left" ou "right".`,
  "schema.resource.identifier.unavailable": (actual: string) =>
    `L'identifiant ${actual} spécifié dans le champ "resource.identifier" n'existe pas dans le projet.`,
  "schema.layer.encoding": (identifier: string, column: string) =>
    `Le couple (${identifier}, ${column}) n’est pas préalablement défini comme une ressource dans la section "data"`,
};

export default fr;
